import * as stylex from '@stylexjs/stylex'
import { type ElementType } from 'react'
import { Box, type BoxProps } from '../Box/Box'

const baseStyles = stylex.create({
  root: {
    display: 'flex',
  },
})

/** Stack 的 props，繼承 Box 的所有 ExtendStyleProps。 */
export type StackProps<RootComponent extends ElementType = 'div', BoxElement extends HTMLElement = HTMLDivElement> = BoxProps<RootComponent, BoxElement>

/**
 * Stack 是基礎的 flex 容器元件，預設為 display: flex。
 * 繼承 Box 的所有 ExtendStyleProps。
 */
export function Stack<RootComponent extends ElementType = 'div', BoxElement extends HTMLElement = HTMLDivElement>(
  props: StackProps<RootComponent, BoxElement>,
) {
  const { component = 'div', rootStyle, ...rest } = props
  return (
    <Box component={component} rootStyle={[baseStyles.root, rootStyle]} {...rest} />
  )
}
